<template>
  <div class="action-card-wrapper">
    <div class="content">
      <header>
        <div>
          <h4 class="allow-select" @click="$emit('edit', action)">
            {{ action.id }}. {{ action.name }}
            <i class="fas fa-pen pen-icon"></i>
          </h4>
          <span class="subtitle">{{ action.title }}</span>
        </div>
        <div class="right-header">
          <span class="badge" :class="action.enabled === 'Да' ? 'badge-success' : 'badge-secondary'">
            {{ action.enabled }}
          </span>
        </div>
      </header>

      <div class="body">
        <div class="info-row" v-if="action.status">
          <span class="label">Статус:</span>
          <span class="value">{{ action.status }}</span>
        </div>
        <div class="info-row" v-if="action.username">
          <span class="label">Кем создан:</span>
          <span class="value">{{ action.username }}</span>
        </div>
        <div class="info-row" v-if="action.date">
          <span class="label">Дата:</span>
          <span class="value">{{ action.date }}</span>
        </div>
        <div class="info-row" v-if="action.parent_action">
          <span class="label">Родительское действие:</span>
          <span class="value">{{ action.parent_action }}</span>
        </div>
        <div class="info-row" v-if="action.back_action">
          <span class="label">Возвратное действие:</span>
          <span class="value">{{ action.back_action }}</span>
        </div>
      </div>

      <div class="actions-board">
        <button class="action-button edit" @click="$emit('edit', action)">
          <i class="fas fa-edit"></i> Редактировать
        </button>
        <button class="action-button delete" @click="$emit('delete', action)">
          <i class="fas fa-trash"></i> Удалить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionCard",
  props: {
    action: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.action-card-wrapper {
  transition: .2s;

  .content {
    box-shadow: 0 0 3px 0 #00000026;
    background: white;
    padding: 20px;
    border-radius: 10px;
    transition: all .2s;

    header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #00000010;

      h4 {
        margin: 0;
        font-size: 18px;
        transition: .2s;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;

        @media screen and (max-width: 400px) {
          font-size: 14px;
        }

        .pen-icon {
          font-size: 12px;
          opacity: 0;
          transition: .2s;
        }

        &:hover {
          color: #7366ff;

          .pen-icon {
            opacity: 1;
          }
        }
      }

      .subtitle {
        font-size: 12px;
        color: gray;
        display: block;
        margin-top: 5px;
      }

      .right-header {
        .badge {
          font-size: 11px;
          padding: 5px 10px;
          border-radius: 13px;
        }

        .badge-success {
          background-color: #28a745;
          color: white;
        }

        .badge-secondary {
          background-color: #6c757d;
          color: white;
        }
      }
    }

    .body {
      margin-bottom: 15px;

      .info-row {
        display: flex;
        justify-content: space-between;
        padding: 8px 0;
        font-size: 13px;

        &:not(:last-child) {
          border-bottom: 1px solid #00000008;
        }

        .label {
          color: #808080c7;
          font-weight: 500;
        }

        .value {
          color: #2b2b2b;
          text-align: right;
        }
      }
    }

    .actions-board {
      display: flex;
      gap: 10px;
      margin-top: 15px;

      @media screen and (max-width: 405px) {
        flex-direction: column;
      }

      .action-button {
        flex: 1;
        font-size: 11px;
        border-radius: 13px;
        padding: 8px 15px;
        border: none;
        transition: .2s;
        cursor: pointer;

        &.edit {
          background: #7366ff;
          color: white;

          &:hover {
            background: #5a4fd4;
          }
        }

        &.delete {
          background: #dc3545;
          color: white;

          &:hover {
            background: #c82333;
          }
        }
      }
    }
  }
}
</style>